import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import TableFunction from '../RecommendationTable/TableFunction';
import { Styles } from '../RecommendationTable/TableStyling';
import { Pagination } from '../Pagination/Pagination';
import { pushRiskInitialLimit, pushRiskInitialOffset } from '../../../slices/RiskFilterSlice';
import { getPostResponseAPIData } from '../../../services/apiservices';
import { accountFilterUrl, originFilterUrl } from '../../../constants/constants';
import { pushRiskInitialSortBy, pushAccountRiskInitialSortBy, pushAccountRiskInitialLimit, pushAccountRiskInitialOffset } from '../../../slices/RiskFilterSlice';
import { pushShowSpinner } from '../../../slices/SpinnerSlice';
import CircularProgress from '@material-ui/core/CircularProgress';
import { pushRiskTableData } from '../../../slices/recommendationTableSlice';
import styled from 'styled-components';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
export const StyledSpinnerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const StyledDataDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 350px;
  background: rgba(235, 237, 239, 0.4);
`;

const RiskTable = props => {
  const clickEvent = useSelector(state => state.applicationDrillHeatMap.clickEvent);
  const dashboardColumnData = useSelector(state => state.riskFilterSlice.dashboardColumnData);
  const drillColumnData = useSelector(state => state.riskFilterSlice.drillColumnData);
  const selectedApplication = useSelector(state => state.heatMapSlice.selectedApplication);
  let tabledata = !clickEvent || !selectedApplication ? dashboardColumnData : drillColumnData;
  const riskTableData = useSelector(state => state.recommendationTable.riskTableData);

  const processColumns = (results = []) => {
    let cols = [];

    if (results.length > 0) {
      results.forEach(key => {
        let isHidden = key.accessor === 'underWatch'; // Default Ids should be hidden

        let isRecommandation = key.accessor === 'impactResult';
        cols.push({
          align: 'left',
          hidden: key['hidden'],
          Header: isHidden ? '' : isRecommandation ? 'Recommendation' : startCase(camelCase(key['Header'])),
          accessor: key['accessor'],
          width: isHidden ? 40 : isRecommandation ? 190 : Math.min(400, startCase(camelCase(key['Header'])).length * 10),
          opacity: '87%'
        });
      });
      return cols;
    }
  };

  const generateData = () => {
    let columns = processColumns(tabledata);
    let rows = [];

    if (riskTableData && riskTableData.length > 0) {
      let test = riskTableData.filter(item => item.originRiskScore !== 0);
      rows = test.map(row => row);
    }

    return {
      rows,
      columns
    };
  };

  let resultColumns = generateData().columns;
  const applyEvent = useSelector(state => state.riskFilterSlice.applyEvent);
  const originRiskFilterResponse = useSelector(state => state.recommendationTable.originFilter);
  const accountRiskFilterResponse = useSelector(state => state.recommendationTable.accountFilter);
  const spinnerStatus = useSelector(state => state.spinner.loading);
  const apiResponseData = useSelector(state => state.recommendationTable.riskTableResponse);
  const {
    data = {}
  } = clickEvent || selectedApplication ? applyEvent ? accountRiskFilterResponse || {} : props.risknextTableData || {} : applyEvent ? originRiskFilterResponse || {} : props.risknextTableData || {};
  const {
    pageNumber = 0
  } = data || {};
  const {
    totalElements = 0
  } = data || {};
  const {
    pageSize = 10
  } = data || {};
  const [riskPageNumber, setRiskPageNumber] = React.useState(0);
  const [riskRowsPerPage, setRiskRowsPerPage] = React.useState(10);
  const [riskFilterTableSortOrder, setRiskFilterTableSortOrder] = React.useState('DSC');
  const [riskFilterTableSortOrderBy, setRiskFilterTableSortOrderBy] = React.useState('originRiskScore');
  const [accountRiskFilterTableSortOrder, setAccountRiskFilterTableSortOrder] = React.useState('DSC');
  const [accountRiskFilterTableSortOrderBy, setAccountRiskFilterTableSortOrderBy] = React.useState('users');
  const riskReqBody = useSelector(state => state.riskFilterSlice.riskReqBody);
  const accountRiskReqBody = useSelector(state => state.riskFilterSlice.accountRiskReqBody);
  const dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    if (clickEvent || selectedApplication) {
      if (applyEvent) {
        setRiskPageNumber(newPage);
        dispatch(pushRiskInitialOffset(newPage));
      } else {
        props.setRiskTablePage(newPage);
      }
    } else {
      if (applyEvent) {
        setRiskPageNumber(newPage);
        dispatch(pushRiskInitialOffset(newPage));
      } else {
        props.setRiskTablePage(newPage);
      }
    }
  };

  const handleChangeRowsPerPage = event => {
    if (clickEvent || selectedApplication) {
      if (applyEvent) {
        setRiskPageNumber(0);
        setRiskRowsPerPage(parseInt(event.target.value, 10));
        dispatch(pushAccountRiskInitialOffset(0));
        dispatch(pushAccountRiskInitialLimit(parseInt(event.target.value, 10)));
      } else {
        props.setRiskTablePage(0);
        props.setRiskTableRowsRowsPerPage(parseInt(event.target.value, 10));
      }
    } else {
      if (applyEvent) {
        setRiskPageNumber(0);
        setRiskRowsPerPage(parseInt(event.target.value, 10));
        dispatch(pushRiskInitialOffset(0));
        dispatch(pushRiskInitialLimit(parseInt(event.target.value, 10)));
      } else {
        props.setRiskTablePage(0);
        props.setRiskTableRowsRowsPerPage(parseInt(event.target.value, 10));
      }
    }
  };

  const handleRequestRiskSort = property => {
    if (clickEvent || selectedApplication) {
      if (applyEvent) {
        const isDsc = accountRiskFilterTableSortOrderBy === property && accountRiskFilterTableSortOrder === 'DSC';
        let sortStringOrder = isDsc ? 'ASC' : 'DSC';
        let sortString = property + ':' + sortStringOrder;
        dispatch(pushAccountRiskInitialSortBy(sortString));
        setAccountRiskFilterTableSortOrder(isDsc ? 'ASC' : 'DSC');
        setAccountRiskFilterTableSortOrderBy(property);
        dispatch(pushRiskTableData([]));
      } else {
        props.handleSetriskTableSortString(property);
        dispatch(pushRiskTableData([]));
      }
    } else {
      if (applyEvent) {
        const isDsc = riskFilterTableSortOrderBy === property && riskFilterTableSortOrder === 'DSC';
        let sortStringOrder = isDsc ? 'ASC' : 'DSC';
        let sortString = property + ':' + sortStringOrder;
        dispatch(pushRiskInitialSortBy(sortString));
        setRiskFilterTableSortOrder(isDsc ? 'ASC' : 'DSC');
        setRiskFilterTableSortOrderBy(property);
        dispatch(pushRiskTableData([]));
      } else {
        props.handleSetriskTableSortString(property);
        dispatch(pushRiskTableData([]));
      }
    }
  };

  useEffect(() => {
    // Reset the page to initial number when the component is mounted.
    props.setRiskTablePage(0);
  }, []);
  useEffect(() => {
    if (applyEvent) {
      if (clickEvent || selectedApplication) {
        dispatch(pushShowSpinner(true));
        dispatch(getPostResponseAPIData(accountFilterUrl, 'accountFilter', accountRiskReqBody));
      } else {
        dispatch(pushShowSpinner(true));
        dispatch(getPostResponseAPIData(originFilterUrl, 'originFilter', riskReqBody));
      }
    }
  }, [riskPageNumber, riskRowsPerPage, riskFilterTableSortOrder, accountRiskFilterTableSortOrder]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, spinnerStatus || apiResponseData?.isLoading ? /*#__PURE__*/React.createElement(StyledSpinnerDiv, null, /*#__PURE__*/React.createElement(CircularProgress, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, generateData().rows.length > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styles, null, /*#__PURE__*/React.createElement(TableFunction, {
    columns: resultColumns,
    data: generateData().rows,
    "min-width": "30px",
    handleSetriskTableSortString: handleRequestRiskSort,
    sortOrder: clickEvent || selectedApplication ? applyEvent ? accountRiskFilterTableSortOrder : props.riskColumOrder : applyEvent ? riskFilterTableSortOrder : props.riskColumOrder,
    sortOrderBy: clickEvent || selectedApplication ? applyEvent ? accountRiskFilterTableSortOrderBy : props.riskColumOderBy : applyEvent ? riskFilterTableSortOrderBy : props.riskColumOderBy,
    isRiskTable: true,
    handleTableRowClick: props.handleTableRowClick,
    isTreemapApplication: props.isTreemapApplication
  })), /*#__PURE__*/React.createElement(Pagination, {
    handleChangePage: handleChangePage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    pageNumber: pageNumber,
    totalElements: totalElements,
    rowsPerEachPage: pageSize
  })) : /*#__PURE__*/React.createElement(StyledDataDiv, null, "No Data !!!")));
};

export default withRouter(RiskTable);